/* Staging pointed at production data: shown over everything, top centre. */
export function ProdDisclaimer() {
  return (
    <div className="sk:fixed sk:top-0 sk:left-1/2 sk:z-999 sk:flex sk:-translate-x-1/2 sk:justify-center sk:rounded-b-lg sk:bg-danger sk:px-3 sk:py-2 sk:text-sm sk:font-semibold sk:text-surface">
      Production environment is connected.
    </div>
  );
}
